export const getTimezone = () =>
  // eslint-disable-next-line new-cap
  Intl.DateTimeFormat().resolvedOptions().timeZone || 'Australia/Melbourne';

export const useTimezone = () => getTimezone();
